<template>
  <div class="card card-info" v-if="state == 'edit'">
    <div class="card-header">
      <h3 class="card-title">Create</h3>
    </div>
    <form v-on:submit="save">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Degree *</label>
              <select class="form-control " v-model="document.DegreeID" required v-on:change="loadDocument()">
                <option value='' selected disabled>---Select Degree---</option>
                <option v-for="item in Degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" v-if="document.DegreeID != ''">
            <label>Documents</label>
            <div class=" table-responsive">
              <table class="table table-bordered table-sm table-striped">
                <thead class="bg-info text-white">
                  <tr>
                    <td>Document Type</td>
                    <td>Required</td>
                    <td>Optional</td>
                    <td>Order By</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in requiredDocs">
                    <td>{{item.Name}}</td>
                    <td align="center">
                      <input class="form-check" type="checkbox" v-model="item.Required">
                    </td>
                    <td align="center">
                      <input class="form-check" type="checkbox" v-model="item.Optional">
                    </td>
                    <td align="center">
                      <input class="form-control" style="width:25%;text-align:right" type="text" v-mask="'###'" required v-model="item.OrderBy">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      <div class="card-footer">
        <button type="button" class="btn btn-primary" v-on:click="Back()">Back to List</button>
        <input type="submit" value="Save" class="btn btn-success float-right" />
      </div>
    </form>
  </div>
  <div class="card card-info" v-else>
    <div class="card-header">
      <h3 class="card-title" style="width: 100%">
        <button v-on:click="stateChange()" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table id="table" class="table table-bordered table-sm text-sm" width="100%">
              <thead class="bg-info">
                <tr>  
                  <td>Degree</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in RequiredDocumentRecord">
                  <td>{{item.Name}}</td>
                  <td align="center"> <i class="fa fa-2x fa-edit" v-on:click="edit(item.DegreeID)"></i></td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        document: { DegreeID: '', Optional: '', Required: '', OrderBy: '', DocumentID: '' },
        Degrees: [],
        state: 'record',
        requiredDocs: [],
        RequiredDocumentRecord: []
      }
    },
    created: function () {
      this.pageLoad();
    },
    methods: {
      stateChange() {
        this.state = 'edit';
      },

      pageLoad() {
        var vm = this;
        startReq();
        axios.get("/api/AdmissionApi/PageLoadDocumentRecord")
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.Degrees = res.data.degree;
              vm.RequiredDocumentRecord = res.data.lst;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
      },

      loadDocument() {
        var vm = this;
        startReq();
        axios.get("/api/AdmissionApi/loadDocuments")
          .then(function (res) {
            vm.requiredDocs = res.data.lst;
            endReq();
          })
      },

      save(e) {
        e.preventDefault();
        var vm = this;
        if (vm.requiredDocs[0].OrderBy == "") {
          toastr.error("Enter OrderBy");
          return;
        }

        axios.post('/api/AdmissionApi/saveRequiredDocs?degID=' + vm.document.DegreeID , {
          lst: vm.requiredDocs,
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done");
              setTimeout(function () { window.location.reload() }, 2000);
            }
            else
              toastr.error(res.data.msg);

          })
      },
      Back() {
        //this.state = 'record';
        location.reload();
      },
      edit(degID) {
        var vm = this;
        axios.post("/api/AdmissionApi/EditRequiredDocument?degID=" + degID)
          .then(function (res) {
            if (res.data.status) {
              vm.state = 'edit';
              var lst = res.data.editReqDocs;
              vm.requiredDocs = lst;
              vm.document.DegreeID = res.data.editReqDocs[0].DegreeID;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
      }

    }
  })
</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/requiredDocument.vue